import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { FahrzeugscheinValueApi } from './FahrzeugdatenFahrzeugscheinValueApi';

/**
 * APIL Url: ADAC.Internet.Core.Models.Fahrzeugdaten.Fahrzeugschein
 * Fahrzeugscheindaten
 * Endpoints: /api/Garage/{id}, /api/Garage
 */
export class FahrzeugscheinApi extends BaseApiModel {
	constructor(initialProperties?: Partial<FahrzeugscheinApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected uploadId: string;
	/**
	 * Description: Id des Fahrzeugschein Uploads
	 * APIL Type: uuid
	 */
	get UploadId(): string {
		return this.uploadId;
	}

	/**
	 * Description: Id des Fahrzeugschein Uploads
	 * APIL Type: uuid
	 */
	set UploadId(value: string) {
		this.uploadId = value;
	}

	protected bild: string;
	/**
	 * Description: Scan des Fahrzeugscheins
	 * APIL Type: string
	 */
	get Bild(): string {
		return this.bild;
	}

	/**
	 * Description: Scan des Fahrzeugscheins
	 * APIL Type: string
	 */
	set Bild(value: string) {
		this.bild = value;
	}

	protected wichtigeDaten: boolean;
	/**
	 * Description: Wichtige Daten bestaetigt
	 * APIL Type: boolean
	 */
	get WichtigeDaten(): boolean {
		return this.wichtigeDaten;
	}

	/**
	 * Description: Wichtige Daten bestaetigt
	 * APIL Type: boolean
	 */
	set WichtigeDaten(value: boolean) {
		this.wichtigeDaten = value;
	}

	protected weitereDaten: boolean;
	/**
	 * Description: Weitere Daten bestaetigt
	 * APIL Type: boolean
	 */
	get WeitereDaten(): boolean {
		return this.weitereDaten;
	}

	/**
	 * Description: Weitere Daten bestaetigt
	 * APIL Type: boolean
	 */
	set WeitereDaten(value: boolean) {
		this.weitereDaten = value;
	}

	protected felder: FahrzeugscheinValueApi[];
	/**
	 * Description: Felder
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Fahrzeugdaten.FahrzeugscheinValue>
	 */
	get Felder(): FahrzeugscheinValueApi[] {
		return this.felder;
	}

	/**
	 * Description: Felder
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Fahrzeugdaten.FahrzeugscheinValue>
	 */
	set Felder(value: FahrzeugscheinValueApi[]) {
		this.felder = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): FahrzeugscheinApi {
		return AppUtils.Helper.createFromMap(dataObject, FahrzeugscheinApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'felder':
					const resultfelder = new Array<FahrzeugscheinValueApi>();
					if (value && Array.isArray(value)) {
						value.forEach((v: any) => {
							resultfelder.push(FahrzeugscheinValueApi.createFromObject(v));
						});
					}
					return resultfelder;
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.UploadId = this.uploadId;
		result.Bild = this.bild;
		result.WichtigeDaten = this.wichtigeDaten;
		result.WeitereDaten = this.weitereDaten;
		const felderArrayReqObject: object[] = [];
		this.felder.forEach((element) => {
			felderArrayReqObject.push(element.toRequestObject());
		});
		result.Felder = felderArrayReqObject;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}